import { Pipe, PipeTransform } from '@angular/core';
import { TableCell } from '@nagel-types';

@Pipe({
    name: 'mapToText',
    standalone: true,
})
export class MapToTextPipe<T extends string | number> implements PipeTransform {
    transform(cell: TableCell): string {
        const { valuesMap } = cell.options || {};

        const mapperKey = cell.value as T;

        return valuesMap?.[mapperKey] || '---';
    }
}
